export default __webpack_public_path__ + "4e300e917a9d3b666f92bab520c21bed.png";